<template>
	<el-dialog class="callout_link" ref="callout_link" :modal=false :append-to-body=true :title="editDial.artTitle" :visible.sync="editDial.setlink" width="40%">
		<div class="link_con">
			<el-form ref="form" :model="form" label-width="120px">
				<el-form-item label="链接类型：" label-width="120px">
					<el-radio-group v-model="form.newLinkTypeSwitch">
						<el-radio label="1">站内链接</el-radio>
						<el-radio label="2">功能</el-radio>
						<el-radio label="3">站外链接</el-radio>
					</el-radio-group>
				</el-form-item>
			</el-form>
			<el-form v-show="form.newLinkTypeSwitch==1" ref="form0" :model="form" label-width="120px">
				<el-form-item label="一级导航：">
					<el-select v-model="form0.firtTitle" @change="changFistType" placeholder="请选择链接">
						<el-option v-for="rut in navItem" :key="rut.id" :label="rut.column_name" :value="rut.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="二级导航：">
					<el-select v-model="form0.secTitle" @change="changSecType" placeholder="请选择栏目">
						<el-option v-for="(sec,index) in secondNav" :key="sec.id" :label="sec.column_name" :value="sec.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="三级导航：">
					<el-select v-model="form0.thirTitle" @change="changThirType" placeholder="请选择栏目">
						<el-option v-for="(sec,index) in thirdNav" :key="index" :label="sec.column_name" :value="sec.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="打开方式：">
					<el-checkbox-group v-model="form0.openByNewPage" @change="setOpen()">
						<el-checkbox label="在新页面打开" name="type"></el-checkbox>
					</el-checkbox-group>
				</el-form-item>
			</el-form>
			<el-form v-show="form.newLinkTypeSwitch==2" ref="form" :model="form1" label-width="120px">
				<el-form-item label="选择功能：">
					<el-select v-model="form1.newMenuWord" placeholder="请选择链接">
						<el-option v-for="(sec,index) in showType" :key="index" :label="sec.text" :value="sec.id"></el-option>
						<!--el-option label="区域二" value="beijing"></el-option-->
					</el-select>
				</el-form-item>
				<el-form-item label="选择弹窗：">
					<el-select v-model="form1.popupZoneBox" @change="popupFun()" placeholder="请选择栏目">
						<el-option v-for="(sec,index) in popUps" :key="index" :label="sec.mTxt" :value="sec.allId">
							<span style="float: left">{{ sec.mTxt }}</span>
							<span @click="delArt(sec)" style="float: right; color: #8492a6; font-size: 13px"> 删除</span>
							<span @click="editArt(sec)" style="float: right; color: #8492a6; font-size: 13px">编辑</span>

						</el-option>
						<!--el-option label="区域二" value="beijing"></el-option-->
					</el-select>
					<div @click="createPop()" class="create_pop">
						<span>新建弹窗</span>
					</div>
				</el-form-item>
			</el-form>
			<el-form v-show="form.newLinkTypeSwitch==3" ref="form" :model="form2" label-width="120px">
				<el-form-item label="站外链接：">
					<el-input v-model="form2.cusLink" style="width: 220px;" @blur="changecusLink"></el-input>
				</el-form-item>
				<el-form-item label="打开方式：">
					<el-checkbox-group v-model="form2.openByNewPage" @change="setOpen()">
						<el-checkbox label="在新页面打开" name="type"></el-checkbox>
					</el-checkbox-group>
				</el-form-item>
			</el-form>
		</div>
		<span slot="footer" class="dialog-footer">
    <el-button @click="cancel">取 消</el-button>
    <el-button type="primary" @click="mSave">确 定</el-button>
  </span>
	</el-dialog>
</template>

<script>
	import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
	import bus from '@/common/bus.js'
	import api from '@/api/$ajax.js'
	export default {
		name: 'uiLink',
		created() {
			this.getData();
		},
		components: {

		},
		props: ['itemMdata', 'editDial'],
		mounted() {

		},
		methods: {
			setOpen() {
				let ts = this;
				if(ts.form.newLinkTypeSwitch == 1 && ts.form0.openByNewPage == true) {
					ts.itemMdata.target = '_blank';
				} else if(ts.form.newLinkTypeSwitch == 1 && ts.form0.openByNewPage == false) {
					ts.itemMdata.target = '_self';
				}
				if(ts.form.newLinkTypeSwitch == 3 && ts.form2.openByNewPage == true) {
					ts.itemMdata.target = '_blank';
				} else if(ts.form.newLinkTypeSwitch == 3 && ts.form2.openByNewPage == false) {
					ts.itemMdata.target = '_self';
				}
				ts.$emit('setLink', ts.itemMdata);
			},
			editArt(item) {
				let ts = this;
				item.isShow = true;
				ts.$emit('closeArtD');
				bus.$emit("closedial");
				setTimeout(function() {
					online.mounted($("#" + item.allId + " .art_m_outer"), "move_art");
					ts.$utils.autoCenter($('.art_m_outer')[0]);
					window.onresize = function() {
						ts.$utils.autoCenter($('.art_m_outer')[0]);
					};
				}, 300);

				// console.log("edit:" + item);
			},
			delArt(comp) {
				let ts = this;
				// console.log("del:" + comp);
				ts.delItemArtD(comp);
				ts.orderbyId();
				ts.saveloca(ts.param);
			},
			changFistType() {
				let ts = this;
				let navItem = ts.navItem;
				ts.itemMdata.link = ts.form0.firtTitle;
				// 轮播图链接
				ts.itemMdata.link_url = ts.form0.firtTitle;
				ts.itemMdata.artId = "";
				ts.$emit('setLink', ts.itemMdata);
				for(let i = 0; navItem.length > i; i++) {
					if(navItem[i].id == ts.form0.firtTitle) {
						ts.secondNav = navItem[i].secondNav || [];
						ts.form0.secTitle = "";
					}
				}
			},
			changSecType() {
				let ts = this;
				let navItem = ts.navItem;
				ts.itemMdata.link = ts.form0.secTitle;
				//轮播图链接
				ts.itemMdata.link_url = ts.form0.secTitle;
				ts.itemMdata.artId = "";
				// sconsole.log(this.itemMdata.link_url)
				ts.$emit('setLink', ts.itemMdata);
				// debugger;
				for(let i = 0; navItem.length > i; i++) {
					let secondNav = navItem[i].secondNav;
					for(let j = 0; secondNav.length > j; j++) {
						if(secondNav[j].id == ts.form0.secTitle) {
							ts.thirdNav = secondNav[j].thirdNav || [];
							ts.form0.thirTitle = "";
						}
					}
				}
			},
			cancel() {
				this.editDial.setlink = false;
			},
			mSave() {
				this.editDial.setlink = false;
			},
			createPop(item) {
				let ts = this;
				if(!item) {
					ts.artObj.allId = "art" + ts.$utils.GenNonDuplicateID();
					item = ts.artObj;
				}
				ts.itemMdata.artId = ts.artObj.allId;
				ts.itemMdata.link = "";
				ts.$emit('closeArtD');
				bus.$emit("closedial");
				bus.$emit("createArtD", item);
				setTimeout(function() {
					online.mounted($("#" + item.allId + " .art_m_outer"), "move_art");
					ts.$utils.autoCenter($('.art_m_outer')[0]);
					window.onresize = function() {
						ts.$utils.autoCenter($('.art_m_outer')[0]);
					};
				}, 300);

			},
			getData() {
				let ts = this;
				let columnList = JSON.parse(localStorage.getItem("columnList")) || [];
				let list = columnList;
				let firstList = [];

				for(let i = 0; list.length > i; i++) {
					list[i].secondNav = [];
					if(list[i].parent_id == 0) {
						firstList.push(list[i])
					}
				}

				for(let i = 0; firstList.length > i; i++) {
					for(let k = 0; list.length > k; k++) {
						list[k].thirdNav = [];
						if(firstList[i].id == list[k].parent_id) {
							firstList[i].secondNav.push(list[k]);
						}
					}
				}

				for(let i = 0; firstList.length > i; i++) {
					for(let k = 0; firstList[i].secondNav.length > k; k++) {
						for(let j = 0; list.length > j; j++) {
							if(firstList[i].secondNav[k].id == list[j].parent_id) {
								firstList[i].secondNav[k].thirdNav.push(list[j]);
							}
						}
					}
				}

				ts.navItem = firstList;
				// debugger
				ts.popUps = ts.getDataCur.artD;
				//console.log(ts.getDataCur.artD);
				//});
			},
			popupFun() {
				let ts = this;
				ts.itemMdata.artId = ts.form1.popupZoneBox;
				ts.itemMdata.link = "";
				ts.$emit('setLink', ts.itemMdata);
			},
			changThirType() {
				let ts = this;
				if(ts.form0.thirTitle) {
					ts.itemMdata.link = ts.form0.thirTitle;
					//轮播图链接
					ts.itemMdata.link_url = ts.form0.thirTitle;
					ts.itemMdata.artId = "";
					ts.$emit('setLink', ts.itemMdata);
					
				}
			},
			changecusLink() {
				let ts = this;
				if(ts.form2.cusLink) {
					ts.itemMdata.link = ts.form2.cusLink;
					//轮播图链接
					ts.itemMdata.link_url = ts.form2.cusLink;
					ts.itemMdata.artId = "";
					ts.$emit('setLink', ts.itemMdata);
				}
			},
			...mapActions([
				'saveloca'
			]),
			...mapMutations([
				'orderbyId',"delItemArtD"
			])

		},
		computed: {
			...mapGetters(["getDataCur", "state"])
		},
		data() {
			return {
				title: "设置链接",
				param: {
					id: this.$route.params.id,
					param: this.$route.params.param,
					company_id: this.$route.query.company_id,
					token: this.$route.query.token,
					column_id: this.$route.query.column_id,
					type: this.$route.query.type,
					version_id: this.$route.query.pc_version_id
				},
				artObj: {
					tName: "popUpsLayout",
					tText: "弹窗容器",
					mTxt: "弹窗标题",
					mClass: "Typesetting",
					isEdit: false,
					isShow: true,
					editorId: "",
					emitStr: "",
					bgkOption: 0,
					bgkMode: 0,
					bgkMidOption: 0,
					bgkMidMode: 0,
					draging: false,
					itemInner: [],
					zinStyle: {
						backgroundColor: "none",
						url: "",
						width: "600px",
						height: "600px",
						backgroundImage: "",
						opacity: 1
					},
					mImage0: {
						flag: "conStyle",
						url: "",
					},
					mImage1: {
						flag: "layoutOuterStyle",
						url: "",
					},
					layoutOuterStyle: {
						backgroundImage: "",
						backgroundColor: ""
					},
					bg_hid: false,
					conStyle: {
						marginTop: '0',
						borderColor: "",
						position: "",
						borderStyle: "none",
						borderWidth: "1px",
						borderBottomWidth: "",
						borderTopWidth: "",
						borderLeftWidth: "",
						borderRightWidth: "",
						borderTop: "none",
						marginLeft: '0',
						marginRight: '0',
						backgroundColor: "none",
						marginBottom: '0'
					},
					isAllSite: false,
					isHead: true,
					headStyle: {
						border: "",
						margin: "",
						width: "100%",
						height: "auto",
						backgroundColor: "#0D83ED",
						backgroundImage: "",
						color: "#fff",
					},
					aloneIcon: "panelModuleIcon_fullmeasure moduleArea_fullmeasure",
					aloneText: "moduleAloneText"
				},
				showType: [{
					id: 1,
					text: "弹窗"
				}],
				popUps: [{
					id: 1,
					mTxt: "弹窗1"
				}],
				form: {
					newLinkTypeSwitch: "1"
				},
				navItem: [],
				secondNav: [],
				thirdNav: [],
				form0: {
					firtTitle: '',
					secTitle: '',
					thirTitle: '',
					openByNewPage: true,
					//checked: ''
				},
				form1: {
					popupZoneBox: '',
					newMenuWord: ''
				},
				form2: {
					cusLink: "",
					openByNewPage: true,
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.create_pop {
		display: inline-block;
		margin-left: 10px;
		cursor: pointer;
	}
</style>


// WEBPACK FOOTER //
// src/components/t1/m/uiLink.vue